export default "__VITE_ASSET__3efaa7c9__"